import { useCfgParam } from './useCfgParam';
import { getIsMobile } from '../utils/helpers';

export const getLocalStorageKey = (subUrl: string) => {
  const myseptimKey = 'myseptim';
  const isMobile = getIsMobile();
  let urlKey: string = isMobile ? '/' : subUrl ? subUrl : '/';
  if (!urlKey.startsWith('/')) {
    urlKey = `/${urlKey}`;
  }
  return `${myseptimKey}${urlKey}`;
};

const useLocalStorageKey = () => {
  const subUrl = useCfgParam('subUrl');
  return getLocalStorageKey(subUrl);
};

export default useLocalStorageKey;
